<template>
  <div>
    <home-profile />
    <home-contract />
  </div>
</template>

<script>
import HomeContract from "./HomeContract.vue"
import HomeProfile from "./HomeProfile.vue"

export default {
  components: {
    HomeProfile,
    HomeContract,
  },
}
</script>
